import { queryKeys } from '@/shared/hooks';

export const executionKeys = {
  suiteRuns: (projectId?: string | null, orgId?: string | null) =>
    queryKeys.suiteRuns(projectId, orgId),
  suiteRunDetail: (id: string | null, orgId?: string | null) => queryKeys.suiteRunDetail(id, orgId),
  suiteRunNumber: (id: string | null, orgId?: string | null) =>
    [...queryKeys.suiteRunDetail(id, orgId), 'run-number'] as const,
  suiteRunDetailByRunNumber: (
    suiteSlug: string | null,
    runNumber: number | null,
    projectId?: string | null,
    orgId?: string | null,
  ) =>
    [
      'suiteRuns',
      'detail-run',
      orgId ?? 'personal',
      projectId ?? 'unknown-project',
      suiteSlug ?? 'unknown',
      runNumber ?? 'unknown',
    ] as const,
  suiteRunDetailByRunNumberPrefix: (
    suiteSlug: string | null,
    projectId?: string | null,
    orgId?: string | null,
  ) =>
    [
      'suiteRuns',
      'detail-run',
      orgId ?? 'personal',
      projectId ?? 'unknown-project',
      suiteSlug ?? 'unknown',
    ] as const,
  testRuns: (projectId?: string | null, orgId?: string | null) =>
    queryKeys.testRuns(projectId, orgId),
  testRunDetail: (id: string | null, orgId?: string | null) => queryKeys.testRunDetail(id, orgId),
  testRunDetailByRunNumber: (
    testSlug: string | null,
    runNumber: number | null,
    projectId?: string | null,
    orgId?: string | null,
  ) =>
    [
      'testRuns',
      'detail-run',
      orgId ?? 'personal',
      projectId ?? 'unknown-project',
      testSlug ?? 'unknown',
      runNumber ?? 'unknown',
    ] as const,
};
